import { useParams } from '@tanstack/react-router';
import { useEffect } from 'react';
import type { UseQueryExecute } from 'urql';
import useAuth from './auths/useAuth';

interface IProps {
  refetch: UseQueryExecute;
}
const useRootUserRevalidation = ({ refetch }: IProps) => {
  const { isRootUserValidated } = useAuth();
  const {
    organizationSlug,
    eventId,
    playerId,
    _splat: itemId,
  } = useParams({
    strict: false,
  });

  useEffect(() => {
    if (isRootUserValidated) {
      if (organizationSlug || eventId || playerId || itemId) {
        refetch();
      }
    }
  }, [
    isRootUserValidated,
    refetch,
    organizationSlug,
    eventId,
    playerId,
    itemId,
  ]);
};

export default useRootUserRevalidation;
